// ===== Hero banner full-click behavior =====
// Makes any Dawn "banner" with a primary .button-link fully clickable,
// using the same URL as the first button inside it.

document.addEventListener('DOMContentLoaded', function () {
  try {
    // Grab all banners on the page (homepage usually has 1 main hero)
    var banners = document.querySelectorAll('.banner');

    if (!banners || !banners.length) return;

    banners.forEach(function (banner) {
      // Find the first anchor that looks like a primary CTA button
      var primaryButton = banner.querySelector('a.button, a.button--primary, a.banner__buttons a');

      if (!primaryButton || !primaryButton.href) return;

      var targetUrl = primaryButton.href;

      // Make the whole banner look clickable
      banner.style.cursor = 'pointer';

      banner.addEventListener('click', function (event) {
        // If user clicked a real link or interactive element, don't override
        if (event.target.closest('a, button, input, select, textarea')) {
          return;
        }

        // Follow the same URL as the primary button
        if (targetUrl) {
          window.location.href = targetUrl;
        }
      }, { passive: true });
    });
  } catch (e) {
    if (console && console.warn) {
      console.warn('Hero banner click script error:', e);
    }
  }
});
